module.exports = __webpack_public_path__ + "img/undertakingCases18.67719566.jpg";